import { useEffect, useState } from 'react';
import API from './api';

// Fetches /stories/social-proof once per session and shares the result
// across all components (hero line, live activity bar, register page).
// Returns null until loaded — and stays null on error, so consumers
// render nothing rather than zeros.
let cached = null;
let inflight = null;

const useSocialProof = () => {
  const [stats, setStats] = useState(cached);

  useEffect(() => {
    if (cached) return undefined;
    if (!inflight) {
      inflight = API.get('/stories/social-proof')
        .then(res => { cached = res.data; return cached; })
        .catch(() => null);
    }
    let mounted = true;
    inflight.then(data => { if (mounted && data) setStats(data); });
    return () => { mounted = false; };
  }, []);

  return stats;
};

// Rounds a count down to a marketing-friendly floor: 137 → "100+",
// 1,840 → "1,000+". Returns null below the smallest tier so callers
// can hide the claim entirely instead of showing tiny numbers.
const NICE_TIERS = [50, 100, 250, 500, 1000, 2500, 5000, 10000, 25000, 50000, 100000];

export const niceCount = (n) => {
  let best = null;
  for (const tier of NICE_TIERS) {
    if (n >= tier) best = tier;
  }
  return best ? `${best.toLocaleString()}+` : null;
};

export default useSocialProof;
